import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { listProjectTechs } from '../../../modules/projectModule/projectTechs';
import { setTech, viewTech } from '../../../modules/projectModule/tech';
import { viewTechRslt } from '../../../modules/projectModule/techRslt';
import { viewTechPlan } from '../../../modules/projectModule/techPlan';
import TechEditStepperModal from '../../../components/projectmng/support/TechEditStepperModal';

import { listMidTechs } from '../../../modules/projectModule/techMids';
import * as techApi from '../../../lib/api/tech';



const TechEditStepperModalContainer = ({ open, handleClose, project, reqId }) => {
    const dispatch = useDispatch();


    const [activeStep, setActiveStep] = useState(0);
    const [activeTab, setActiveTab] = useState(0);

    const { tech, techPlan, techMids, techMidInfo, techRslt, user, } = useSelector(({ projectModule, auth }) => ({
        user: auth.user,
        tech: projectModule.tech.tech,
        techPlan: projectModule.techPlan.techPlan,
        techMids: projectModule.midTechs.techMids,
        techMidInfo: projectModule.midTechs.techMidInfo,
        techRslt: projectModule.techRslt.techRslt,
    }));

    useEffect(() => {
        if (reqId) {
            //tech 정보 가져오기
            dispatch(viewTech(reqId));
        }
    }, [reqId]);


    useEffect(() => {
        if (tech) {
            const step = parseInt(tech.reqGrade) - 1;
            const tab = getActiveTap(tech.reqGrade);
            setActiveStep(step);
            setActiveTab(tab);
        }
    }, [tech])

    const checkMidTab = (techPlan) => {
        return techPlan?.plnTyp.includes('장기') ? 2 : 3;
    }

    const getActiveTap = (grade) => {
        let tab = 0
        if (grade === "1") {
            tab = 0;
        } else if (grade === "2") {//지원확인
            tab = 1;
        } else if (grade === "3") {//작업계획
            tab = checkMidTab(techPlan);

        } else if (grade > 3) {
            tab = 3;
        }
        return tab;
    }

    useEffect(() => {
        if (tech && tech?.planUuid !== null && tech?.planUuid !== '') {
            dispatch(viewTechPlan(tech.planUuid));
            const searchData = { "reqUuid": tech?.reqUuid, "planUuid": tech?.planUuid, "prjUuid": tech?.prjUuid };
            dispatch(listMidTechs(searchData));
        }
    }, [tech])

    useEffect(() => {
        if (tech && tech?.rsltUuid !== null && tech?.rsltUuid !== '') {
            dispatch(viewTechRslt(tech.rsltUuid));
        }
    }, [tech])


    const handleTabChange = (event, newValue) => {
        // console.log(newValue, 'newValue')
        // let newStep = newValue;
        setActiveTab(newValue)
    }

    const reloadTech = async (id) => {

        try {
            const res = await techApi.getTechById(id);
            if (res.data.info) {
                dispatch(setTech(res.data.info));
            }
        } catch (err) {
            console.log(err)
        }
    }



    const onClose = () => {
        dispatch(listProjectTechs(tech.prjUuid));
        handleClose();
    }


    if (!project || !tech) {
        return null;
    }



    return (
        <TechEditStepperModal
            open={open}
            activeStep={activeStep}
            activeTab={activeTab}
            tech={tech}
            techRslt={techRslt}
            techPlan={techPlan}
            techMids={techMids}
            techMidInfo={techMidInfo}
            project={project}
            user={user}
            handleClose={onClose}
            reloadTech={reloadTech}
            handleTabChange={handleTabChange}
        />
    )
}


export default TechEditStepperModalContainer